<template>
  <div>
    <!-- If there are no notifications -->
    <div v-if="firstFiveLatestNotifications.length === 0 && readNotifications.length === 0" class="bell-container text-center">
      <img src="@/assets/images/contacts/bellImage.png" class="bell-image" />
      <h4 class="mt-5">No notifications yet . . .</h4>
    </div>
    <!-- Here we show the first five notifiactions -->
    <div class="vx-card p-6" v-else-if="firstFiveLatestNotifications.length > 0">
      <h3 class="text-left">Unread Notifications</h3>
      <ul>
        <li class="vx-card p-3 mt-5" v-for="ntf in firstFiveLatestNotifications" :key="ntf.index">
          <div class="notification border-solid border-b-0 border-r-0 border-t-0 cursor-pointer" @click="automation(ntf)">
            <div class="failed-entry">
              <alert-triangle-icon size="2.0x" class="ml-4 alert-icon"></alert-triangle-icon>
              <div class="ml-5">
                <h4>Failed entries reported</h4>
                <p>{{ ntf.msg }}</p>
              </div>
            </div>
            <p>{{ elapsedTime(ntf.time) }}</p>
          </div>
        </li>
      </ul>
      <!-- Here we show the previous notifications -->
      <ul v-if="expand">
        <li class="vx-card p-3 mt-5" v-for="ntf in allNotifications" :key="ntf.index">
          <div class="notification border-solid border-b-0 border-r-0 border-t-0 cursor-pointer" @click="automation(ntf)">
            <div class="failed-entry">
              <alert-triangle-icon size="2.0x" class="ml-4 alert-icon"></alert-triangle-icon>
              <div class="ml-5">
                <h4>Failed entries reported</h4>
                <p>{{ ntf.msg }}</p>
              </div>
            </div>
            <p>{{ elapsedTime(ntf.time) }}</p>
          </div>
        </li>
      </ul>
      <!-- Here we toggle the previous notifications by clicking on the expand and collapse button -->
      <div @click="expandAllNotifications()" v-if="allNotifications.length > 0">
        <h4 class="text-center mt-5 cursor-pointer" v-if="expand">
          collapse
          <span>
            <arrow-up-icon size="1x" class="pt-2"></arrow-up-icon>
          </span>
        </h4>
        <h4 class="text-center mt-5 cursor-pointer" v-else>
          expand
          <span>
            <arrow-down-icon size="1x" class="pt-2"></arrow-down-icon>
          </span>
        </h4>
      </div>
    </div>
    <!-- Here we show the read notifications -->
    <div class="vx-card p-6 mt-5" v-if="readNotifications.length > 0">
      <h3 class="text-left">Read Notifications</h3>
      <ul>
        <li class="vx-card p-3 mt-5" v-for="ntf in readNotifications" :key="ntf.index">
          <div class="notification read-notification border-solid border-b-0 border-r-0 border-t-0 cursor-pointer" @click="automation(ntf)">
            <div class="failed-entry">
              <alert-triangle-icon size="2.0x" class="ml-4 alert-icon-success"></alert-triangle-icon>
              <div class="ml-5">
                <h4>Failed entries reported</h4>
                <p>{{ ntf.msg }}</p>
              </div>
            </div>
            <p>{{ elapsedTime(ntf.time) }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { AlertTriangleIcon, ArrowDownIcon, ArrowUpIcon } from 'vue-feather-icons'
import firebase from 'firebase'
import 'firebase/firestore'

export default {
  name: 'NotificationPannel',
  components: {
    AlertTriangleIcon,
    ArrowDownIcon,
    ArrowUpIcon,
  },
  data() {
    return {
      allNotifications: [],
      firstFiveLatestNotifications: [],
      readNotifications: [],
      expand: false,
    }
  },
  computed: {
    // This computed property is triggered when there is any change in firestore database
    getNotifications() {
      const fetchedData = this.$store.state.DB.notifications
      if (fetchedData) {
        this.populateNotifications(fetchedData)
      }
      return {
        newNotifications: true,
      }
    },
  },
  // This will trigger when there is any change in getNotifications computed property
  watch: {
    getNotifications: {
      handler(newValue) {
        return newValue
      },
    },
  },
  methods: {
    // this method will fetch notifications of failed entries and show them in our notifications page
    async populateNotifications(fetchedData) {
      let data = null
      let notifications = []
      let readNotification = []

      // eslint-disable-next-line no-unused-vars
      notifications = []
      readNotification = []
      data = Object.keys(fetchedData)
      data.forEach((e) => {
        if (fetchedData[e].isSent === false || fetchedData[e].isSent === true) {
          // Here we are pushing the notification into the notifications array if isSeen is false
          if (fetchedData[e].isSeen === false) notifications.push({ time: fetchedData[e].time, msg: fetchedData[e].textContent, id: e })
          // Here we are pushing the notifications into the readNotification array if isSeen is true
          else readNotification.push({ time: fetchedData[e].time, msg: fetchedData[e].textContent })
        }
      })
      // Here we are sorting the unread notifications by date
      notifications.sort(function (a, b) {
        return new Date(b.time) - new Date(a.time)
      })
      this.allNotifications = notifications
      this.firstFiveLatestNotifications = this.allNotifications.splice(0, 5)
      // Here we are sorting the read notifications by date
      readNotification.sort(function (a, b) {
        return new Date(b.time) - new Date(a.time)
      })
      this.readNotifications = readNotification
    },
    // This method is used to fetch the notifications from the firestore
    async fetchNotifications() {
      if (JSON.parse(localStorage.getItem('userInfo')) && JSON.parse(localStorage.getItem('userInfo')).uid) {
        const fetchedData = this.$store.state.DB.notifications
        await this.populateNotifications(fetchedData)
        this.$vs.loading.close()
      }
    },
    // This method is used to navigate to the perticular failed automation
    async automation(data) {
      const splitMsg = data.msg.split(':')
      const automationName = splitMsg[1].split('-')[0].trim()
      const id = splitMsg[2].trim()
      id[0] === '-' ? this.$router.push(`/database/automations/${automationName}/${id}`) : this.$router.push(`/database/automations/${automationName}/-${id}`)
      await firebase
        .firestore()
        .collection('cloudify')
        .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
        .update({
          [`notifications.${data.id}.isSeen`]: true,
        })
    },
    // This method is used to expand the unread notifications
    expandAllNotifications() {
      this.expand = !this.expand
    },
    // This method is used to convert the time into seconds, minutes, houres, days, months and years
    elapsedTime(startTime) {
      const x = new Date(startTime)
      const now = new Date()
      let timeDiff = now - x
      timeDiff /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)

      const hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)

      const days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)

      const years = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
  },
  created() {
    this.$vs.loading()
    setTimeout(() => {
      this.fetchNotifications()
    }, 3000)
  },
}
</script>

<style>
.failed-entry {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.notification {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-color: red;
}
.alert-icon {
  color: red;
}
.alert-icon-success {
  color: green;
}
.read-notification {
  border-color: green;
}
.bell-image {
  width: 150px;
}
.bell-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 380px;
}
.notification-length {
  font-size: 12px;
  color: #fff;
  background-color: red;
  border-radius: 10px;
  padding: 2px;
}
</style>
